import { UserBrowser } from '@/analytics';
import { GoogleAnalyticsWriter } from '@/analytics/googleAnalyticsWriter';
import {
  getStepIndex,
  StepNavigationConfig,
} from '@sales-domain/product-config';
import { createBrowserAnalytics } from '@soluto-private/analytics-browser-writers';
import { isClient } from './isClient';

export const analytics = createBrowserAnalytics({
  httpUrl: '/api/analytics',
  customWriters: [
    new GoogleAnalyticsWriter({
      channel: 'D2C',
      partner:
        isClient() && UserBrowser.Partner ? UserBrowser.Partner : 'Asurion',
      browserId:
        isClient() && UserBrowser.get().UserBrowserId
          ? UserBrowser.get().UserBrowserId
          : 'unknown',
    }),
  ],
  scope: 'd2c-sales-tool',
  sourceApp: 'd2c-sales-tool',
});

export const getStepNumber = (
  steps: StepNavigationConfig[] | undefined,
  stepName: string,
) => {
  return steps ? getStepIndex(steps, stepName) + 1 : 0;
};
